import * as XLSX from 'xlsx'
import {ItemMatchingInput, ItemMatchingInputDTO, NewItemInput, NewItemInputDTO} from '../model/NewItemInput'
import {deleteRow} from '../../util/excel-util'

export const excelColumnHeaderForNewItem = {
    partNumber: 'PART NUMBER (mandatory)',
    orgName: 'MANUFACTURER NAME (mandatory)',
    itemName: 'ITEM NAME (optional)',
    itemDescription: 'ITEM DESCRIPTION (optional)',
    manufacturerId: 'DATX ID (mandatory)'
} as const

export const excelColumnHeaderForPartMatching = {
    partNumber: 'PART_NUMBER',
    orgName: 'ORG_NAME'
} as const

const isNotEmptyCell = (value?: string): boolean => (value ? value.toString().trim().length > 0 : false)

const validatedCell = (value?: string) => {
    if (isNotEmptyCell(value)) return value
    return null
}

export const getItemsFromPartMatchingFile = async (tempFile: File) => {
    const buffer = await tempFile.arrayBuffer()
    const wb = XLSX.read(buffer)
    const content = wb.Sheets[wb.SheetNames[0]]
    const items: ItemMatchingInput[] = XLSX.utils.sheet_to_json<ItemMatchingInput>(content).filter((row) => {
        return (
            validatedCell(row[excelColumnHeaderForPartMatching.orgName]) &&
            validatedCell(row[excelColumnHeaderForPartMatching.partNumber])
        )
    })
    return items.map((item) => new ItemMatchingInputDTO(item))
}

export const getCompanyItemsFromFile = async (tempFile: File) => {
    const buffer = await tempFile.arrayBuffer()
    const wb = XLSX.read(buffer)
    const content = wb.Sheets[wb.SheetNames[0]]
    // delete the first header row
    deleteRow(content, 0)
    const items: NewItemInput[] = XLSX.utils.sheet_to_json<NewItemInput>(content).filter((row) => {
        return (
            validatedCell(row[excelColumnHeaderForNewItem.partNumber]) &&
            validatedCell(row[excelColumnHeaderForNewItem.manufacturerId])
        )
    })
    return items.map((item) => new NewItemInputDTO(item))
}
